<template>
    <div>
        <div class="main_page">


            <div class="login_box">
                <div class="login_input_box">
                    <div class="demo-login">
                        <Login @on-submit="admin_username_submit">
                            <UserName name="username" />
                            <Password name="password" type="password" :password="true" :enter-to-submit="true" />
                            <Password name="auth2_code" type="" :enter-to-submit="true" placeholder="请输入验证码" />
                            <div style="height: 20px"></div>
                            <Submit />
                        </Login>
                    </div>
                </div>
            </div>

            <div class="bottom_beianhao">
                <!-- <button @click="close_timer">点击停止</button> -->

                <span>
                    Copyright © 2023 大湘人力资源集团.
                </span>
                <span style="margin:0 10px;" @click="click_beianhao">
                    湘ICP备2022000332号-1
                </span>
                <span>
                    <img src="https://www.daxiangsys.com/img/gonganwangbei.8459e597.png" alt="">
                    湘公网安备430190020016
                </span>


            </div>


        </div>

    </div>
</template>
  
<script>
var Base64 = require("js-base64").Base64;
const jsSHA = require("jssha");
import { http, open_new_page } from "@/utils/http.js";

export default {
    components: {
        
    },
    data() {
        return {
            current_tab: "qrcode",

        };
    },
    mounted() {
        // //判断手机端与电脑端
        this.is_mobel = this.isMobile()
        this.window_change()
        this.admin_login()

        document.title = '管理员登录';


    },
    methods: {
        isMobile() {
            var userAgentInfo = navigator.userAgent;

            var mobileAgents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];

            var mobile_flag = false;

            //根据userAgent判断是否是手机
            for (var v = 0; v < mobileAgents.length; v++) {
                if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
                    mobile_flag = true;
                    break;
                }
            }
            var screen_width = window.screen.width;
            var screen_height = window.screen.height;

            //根据屏幕分辨率判断是否是手机
            if (screen_width > 325 && screen_height < 750) {
                mobile_flag = true;
            }

            return mobile_flag;
        },

        admin_login() {
            var that = this
            var admin_token = that.$cookies.get(
                "admin_token",
                '/',
                process.env.VUE_APP_COOKIES_DOMAIN
            );
            var admin_private_key = that.$cookies.get(
                "admin_private_key",
                '/',
                process.env.VUE_APP_COOKIES_DOMAIN
            );
            var admin_public_key = that.$cookies.get(
                "admin_public_key",
                '/',
                process.env.VUE_APP_COOKIES_DOMAIN
            );
            var admin_user_info = that.$cookies.get(
                "admin_user_info",
                '/',
                process.env.VUE_APP_COOKIES_DOMAIN
            );


            if (admin_token && admin_private_key && admin_public_key && admin_user_info) {
                
                that.$router.push({ path: "/auth_manage/sys/sys_setting" });


            } else {
                this.super_admin_show = true;
            }



        },


        //管理员登录
        admin_username_submit(valid, { username, password, auth2_code }) {
            var that = this;
            if (valid) {
                var user_name = Base64.encode(username);
                var pass_word_b64 = Base64.encode(password);
                const shaObj = new jsSHA("SHA-256", "TEXT", { encoding: "UTF8" });
                shaObj.update(pass_word_b64);
                var pass_word = shaObj.getHash("HEX");

                let body_data = {
                    username: user_name,
                    password: pass_word,
                    code: auth2_code,
                    scene_data: {
                        browser_id: that.$cookies.get("browser_id"),
                    },
                };
                that.admin_login_loading = true;
                var body = Base64.encode(JSON.stringify(body_data));
                var obj = {
                    data: body,
                };
                http("post", process.env.VUE_APP_HOST + "/login_admin/v1", obj, false)
                    .then((res) => {
                        console.log(res)
                        // 停止员工扫码登录qr验证
                        if (that.check_qrlogin_timer) {
                            clearInterval(that.check_qrlogin_timer)
                        }
                        that.admin_login_loading = false;
                        if (res.code == 0) {

                            that.$cookies.set(
                                "admin_token",
                                res.data.token,
                                res.data.cookie_exp,
                                '/',
                                process.env.VUE_APP_COOKIES_DOMAIN
                            );
                            that.$cookies.set(
                                "admin_private_key",
                                res.data.private_key,
                                res.data.cookie_exp,
                                '/',
                                process.env.VUE_APP_COOKIES_DOMAIN
                            );
                            that.$cookies.set(
                                "admin_public_key",
                                res.data.public_key,
                                res.data.cookie_exp, '/',
                                process.env.VUE_APP_COOKIES_DOMAIN
                            );
                            that.$cookies.set(
                                "admin_user_info",
                                res.data.user_info,
                                res.data.cookie_exp, '/',
                                process.env.VUE_APP_COOKIES_DOMAIN
                            );
                            that.$router.push({ path: "/auth_manage/sys/sys_setting" });

                            that.$Message.success({
                                content: res.msg,
                                duration: 3,
                            });
                        } else {
                            that.$Message.error({
                                content: res.msg,
                                duration: 3,
                            });
                        }
                    })
                    .catch((res) => {
                        that.admin_login_loading = false;
                        console.log(res, "请求出错");
                    });
            }
        },


        window_change() {
            var that = this;
            // <!--把window.onresize事件挂在到mounted函数上-->
            window.onresize = () => {
                return (() => {
                    window.fullHeight = document.documentElement.clientHeight;
                    window.fullWidth = document.documentElement.clientWidth;
                    that.windowHeight = window.fullHeight;  // 高
                    that.windowWidth = window.fullWidth; // 宽
                })()
            };
        },

       
        click_download_app() {
            open_new_page('https://www.daxiangsys.com')

        },

        click_beianhao() {
            open_new_page('https://beian.miit.gov.cn/')
        }
    },
};
</script>
  
<style scoped>
.controller {
    -webkit-animation: bounce-down 3s linear infinite;
    animation: bounce-down 3s linear infinite;
    margin-right: 150px
}

.controller2 {
    -webkit-animation: bounce-down 3s linear infinite;
    animation: bounce-down 3s linear infinite;
    margin-right: 30px
}

@-webkit-keyframes bounce-down {
    25% {
        -webkit-transform: translateY(-10px);
    }

    50%,
    100% {
        -webkit-transform: translateY(0);
    }

    75% {
        -webkit-transform: translateY(10px);
    }
}

@keyframes bounce-down {
    25% {
        transform: translateY(-10px);
    }

    50%,
    100% {
        transform: translateY(0);
    }

    75% {
        transform: translateY(10px);
    }
}

.super_admin_login {
    color: #2d6ebe;
    font-size: 13px;
}

.super_admin_login:hover {
    color: #fff;
}

.head_right {
    margin-right: 50px;
}

.head_left {
    display: flex;
    align-items: center;
}

.qrcode_detail {
    margin-top: 20px;
    font-size: 12px;
    color: #777;
}

.qrcode_detail2 {
    margin-top: 20px;
    font-size: 12px;
    color: #ccc;
    cursor: pointer;
}

.qrcode_detail2:hover {
    color: #195faf;
}

.qrcode_sacn_icon {
    font-size: 40px;
    color: #19be6b;
}

.qrcode_mb {
    padding: 30px 20px 20px 20px;
    background-color: #00000094;
    position: absolute;
    width: 150px;
    height: 150px;
    top: 40px;
    left: 125px;
    font-size: 13px;
    color: #eaeaea;
    font-weight: 600;
}

.qrcode_img {
    width: 150px;
    height: 150px;
    text-align: center;
    border: 1px solid #ccc;
}

.qrcode_img2 {
    width: 150px;
    height: 150px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ccc;
}

.input {
    margin: 10px;
}

.login_input_box {
    text-align: center;
    padding: 40px 40px 40px 40px;
}

.login_input_box4 {
    text-align: center;
    padding: 0px 40px 10px 40px;
}


.login_input_box3 {
    text-align: center;
    position: relative;
    padding: 40px 40px 5px 40px;
    display: flex;
    justify-content: center;
}

.login_input_box2 {
    text-align: center;
    padding: 10px 30px 40px 30px;
}

.login_tabs {
    display: flex;
    justify-content: center;
    padding-top: 20px;
}


.login_tabs_mobile {
    display: flex;
    justify-content: center;
    padding: 20px;
}

.main_inner {
    display: flex;
    align-items: center;
    margin: 100px 0px 0 0;
}

.logo_img {
    width: 40px;
    height: 40px;
    margin-right: 10px;
    margin-bottom: 5px;
}

.main_page {
    height: calc(100vh - 0px);
    background: #fcfcfc;
    background-image: url("/src/assets/image/auth/loginbg2.png");
    background-repeat: no-repeat;
    background-size: cover;
}

.head_title {
    cursor: pointer;
    letter-spacing: 3px;
    font-size: 18px;
    font-weight: 400;
    color: rgb(255, 255, 255);
}

.bottom_beianhao {
    height: 50px;
    text-align: center;
    font-size: 12px;
    color: #ccc;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    width: 100%;


}

.head_box_mobil {
    height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0 0 20px;
}

.head_box {
    background: #195faf;
    height: 55px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0 0 40px;
}

.bg {
    height: 300px;
    width: 460px;
}

.bg2 {
    height: 240px;
    width: 360px;
}


.main {
    display: flex;
    justify-content: center;
}

.mobile_main {
    background-color: #f5f7f9;
    min-height: 100vh;
    overflow: hidden;
}

.login_box {

    position: absolute;
    top: calc(50% - 300px);
    left: calc(50% - 200px);
    border-radius: 5px;
    width: 400px;
    height: 340px;
    background: #ffffff;
    box-shadow: 0 0 10px rgb(222, 223, 224);
}


.login_box_mobile {
    margin: 10px;
    border-radius: 5px;
    height: 330px;
    /* background: #ffffff; */
    /* box-shadow: 0 0 10px rgb(222, 223, 224); */
}
</style>